import MainButton from "~/components/common/mainButton";
import { useAuth } from "~/contexts/providers/auth";
import { useEvent } from "~/contexts/providers/events";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { BookingStatus } from "~/types/event/eventEnums.type";
import { formatNumber } from "~/utils/functions/string.functions";

import styles from "./index.module.scss";

const AccountIntro = () => {
  const { user } = useAuth();
  const { myEvents } = useEvent();
  const { language } = useLanguage();
  const accountTexts =
    language === "En"
      ? englishTranslations.accountPage
      : frenchTranslations.accountPage;

  const attending = myEvents.filter(
    ({ booking }) => booking?.status === BookingStatus.MAIN
  ).length;

  const waitlist = myEvents.filter(
    ({ booking }) => booking?.status === BookingStatus.WAITING
  ).length;

  return (
    <section className="p-1 bbg">
      {/* <h5 className="small-title">Votre Espace Membre</h5> */}
      <div className={styles["account-welcome-container"]}>
        <h2 className={styles.accountWelcome}>
          <span className={styles.welcome}>{accountTexts.welcome}, </span>
          <span className={styles.welcomeName}>
            {(user?.firstname ?? "") + " " + (user?.lastname ?? "")}
          </span>
        </h2>
        <div className={styles.infoContainer}>
          <div className={styles.info}>
            <div className={styles.topInfo}>
              <span className={styles.topButtons}>
                <MainButton className={styles.item} onClick={() => {}}>
                  {accountTexts.member}
                </MainButton>
                &nbsp;
                {/* <MainButton
                  theme="transparent-grey"
                  className={styles.item}
                  onClick={() => {}}
                >
                  Manage Subscription
                </MainButton> */}
              </span>
            </div>

            <div className={styles.bottomInfo}>
              <span className={styles.topBottomInfo}>
                <div className={styles.bottomInfoNumbers}>
                  <span className={styles.buttonLabel}>
                    {accountTexts.attending}&nbsp;
                  </span>
                  <MainButton className={styles.item} onClick={() => {}}>
                    {formatNumber(attending)}
                  </MainButton>
                </div>

                <div className={styles.bottomInfoNumbers}>
                  <span className={styles.buttonLabel}>
                    {accountTexts.waitingList}&nbsp;
                  </span>
                  <MainButton className={styles.item} onClick={() => {}}>
                    {formatNumber(waitlist)}
                  </MainButton>
                </div>
              </span>
            </div>
          </div>
          {user?.profilePicturePath && (
            <picture>
              <img
                src={user.profilePicturePath}
                className={styles.accountImage}
                alt="profile"
              />
            </picture>
          )}
        </div>
      </div>
    </section>
  );
};

export default AccountIntro;
